import { ActionType, ActionTypes, GaActionType } from '../actions/index';
import { IAppState } from '../reducers/index';
//import * as ga from 'react-google-analytics';
import ReactGA from 'react-ga4';
import * as ReactGALegacy from 'react-ga'
import { ComponentClass, ClassAttributes } from "react";
import { getParameterByName } from './query-string-helpers';

export interface IndexRouteProps<Props> {
}

type IndexRoute = ComponentClass<IndexRouteProps<any>>;
export const logger = store => next => action => {
    //console.log('dispatching', { actionType: ActionType[action.type], payload: action.value })
    let result = next(action)

    var shouldLog = getParameterByName('enableLogging');
    if (shouldLog !== null && action.type !== ActionTypes.HOVER_SEAT) {
        console.log("SMARTSEAT_ACTION", "", { type: action.type, value: action.value, result: getParameterByName('logState') ? result : "add 'logState' to query string to log" });
    }

    if (action.type === ActionTypes.TRACK_RESERVE_VALUE) {
        (ReactGALegacy as any).ga('send', 'event', 'Smart Seat Actions', ActionTypes[action.type], versionNumber, action.value);
        (ReactGALegacy as any).ga('adageTracker.send', 'event', window.location.hostname + ':Smart Seat Actions', ActionTypes[action.type], versionNumber, action.value);
        ReactGA.event({ category: 'Smart Seat Actions', action: ActionTypes[action.type], label: versionNumber, value: action.value });
    }
    else if (action.type in GaActionType) {
        if (action.unTrackEvent !== undefined && action.unTrackEvent) {
            //don't track this event in GA
        } else {
            var versionNumber = window["ss-version"];
            if (versionNumber == undefined) {
                versionNumber = "2.9.0"
            }
            (ReactGALegacy as any).ga('send', 'event', 'Smart Seat Actions', ActionTypes[action.type]);
            (ReactGALegacy as any).ga('adageTracker.send', 'event', window.location.hostname + ':Smart Seat Actions', ActionTypes[action.type]);
            ReactGA.event({ category: 'Smart Seat Actions', action: ActionTypes[action.type] });
        }
    }

    var state: IAppState = store.getState();
    let stateToSave = { ...state };
    if (action.type !== ActionTypes.RECEIVE_SETTINGS
        && action.type !== ActionTypes.SELECT_SEAT
        && action.type !== ActionTypes.LOAD_SEATMAP
        && action.type !== ActionTypes.SELECT_NEXT_SEAT
        && action.type !== ActionTypes.SELECT_PREVIOUS_SEAT) {
        delete stateToSave["children"];
        delete stateToSave["dispatch"];
        delete stateToSave["cartModel"];
        delete stateToSave["location"];
        delete stateToSave["seatMapModel"];
        delete stateToSave["seatMapResultModel"];
        delete stateToSave["seatMatchResultModel"];

        var stateJson = JSON.stringify({
            ...stateToSave,
            appSettingsModel: {
                ...stateToSave.appSettingsModel,
                seatmapBackgroundImage: null
            }
        });
    }
    return result
}

//export const crashReporter = store => next => action => {
//    try {
//        return next(action)
//    } catch (err) {
//        //console.error('Caught an exception!', err)
//        //Raven.captureException(err, {
//        //    extra: {
//        //        action,
//        //        state: store.getState()
//        //    }
//        //})
//        throw err
//    }
//}